import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { fetchShop } from 'reducks/shop/operations'
import { getShopRef, getStoreName } from 'reducks/store/selectors'
import { fetchStore } from 'reducks/store/operations'
import { db } from 'firebase/index'
import { AccountSettingsTemplate } from 'components/Templates'

const ShopEditSettings: FC = () => {
  const dispatch = useDispatch()

  const name = useSelector((state: State) => getStoreName(state))
  const shopRef = useSelector((state: State) => getShopRef(state))

  const path = useSelector((state: State) => state.router.location.pathname)
  const isCreatePage = /\/admin\/shops\/create\/settings/.test(path)
  const storeId = path.split('/admin/shops/')[1] ? path.split('/admin/shops/')[1].split('/settings')[0] : undefined

  useEffect(() => {
    if (!storeId) return
    dispatch(fetchStore(db.collection('stores').doc(storeId)))
  }, [])

  useEffect(() => {
    if (!shopRef) return
    dispatch(fetchShop(shopRef.id))
  }, [shopRef])

  return (
    <Layout
      headline={isCreatePage ? '新規店舗作成' : undefined}
      title={isCreatePage ? '新規店舗の商品の受け渡しに関する設定を編集' : `${name}の商品の受け渡しに関する設定を編集`}
    >
      <AccountSettingsTemplate isAdmin={true} storeId={storeId} />
    </Layout>
  )
}

export default ShopEditSettings
